import { render, staticRenderFns } from "./byline_field.vue?vue&type=template&id=38889d4e&lang=pug"
import script from "./byline_field.vue?vue&type=script&lang=js"
export * from "./byline_field.vue?vue&type=script&lang=js"
import style0 from "./byline_field.vue?vue&type=style&index=0&id=38889d4e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports